import { render, staticRenderFns } from "./SecurityRuleItem.vue?vue&type=template&id=b8784fec&"
import script from "./SecurityRuleItem.vue?vue&type=script&lang=js&"
export * from "./SecurityRuleItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports